<template>
  <div>
    <div class="row">
      <div class="col-md-12 fme-content">
        <div class="container-fluid" v-if="selectVisible === true" >
          <div class="row fme-overview-home__title fme-montserrat-font">
            <div class="col-md-2">
              <h1 class="">{{ $t('supervision.overview.pageTitle') | textUpperCase }}</h1>
            </div>

            <div class="col-md-10 fme-overview-period-select text-right">
              <div v-if="currentPeriod">
                <button @click.prevent="updateCurrentPeriod('-')" class="btn fme-btn fme-btn-pager-sample fme-btn-pager__left fme-overview-period-select__button">
                  <font-awesome-icon fas icon="angle-left" class="" />
                </button>
                <button @click.prevent="updateCurrentPeriod('+')" class="btn fme-btn fme-btn-pager-sample fme-btn-pager__right fme-overview-period-select__button" :disabled="hasNoEndPeriod">
                  <font-awesome-icon fas icon="angle-right" class="" />
                </button>
                <div class="fme-overview-period-select__text">
                  <p v-if="currentPeriod === 'monthly'">{{ startEndSelectedPeriod.monthName }}/{{ startEndSelectedPeriod.year }}</p>
                  <p v-else-if="currentPeriod === 'biweekly'">{{ startEndSelectedPeriod.startDay }} à {{ startEndSelectedPeriod.endDay }} {{ startEndSelectedPeriod.monthName }}/{{ startEndSelectedPeriod.year }}</p>
                  <p v-else>
                    <span v-if="startEndSelectedPeriod.startYear === startEndSelectedPeriod.endYear">{{ startEndSelectedPeriod.startDay }}/{{ startEndSelectedPeriod.startMonth }} à {{ startEndSelectedPeriod.endDay }}/{{ startEndSelectedPeriod.endMonth }} {{ startEndSelectedPeriod.year }}</span>

                    <span v-else>{{ startEndSelectedPeriod.startDay }}/{{ startEndSelectedPeriod.startMonth }}/{{ startEndSelectedPeriod.startYear }} à {{ startEndSelectedPeriod.endDay }}/{{ startEndSelectedPeriod.endMonth }}/{{ startEndSelectedPeriod.endYear }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="row fme-overview-menu">
            <div class="col-md-4 fme-overview-select">
              <BaseSelect selectId="select-regions" :selectValues="selectRegions" selectCss="fm-select-group__title--not--margin" :selectCurrentValue="regionId" @returnedSelectValue="regionSelect('region', $event)" :selectTranslate="false" />
            </div>

            <div class="col-md-8 fme-overview-periods">
              <div class="fme-overview-periods__group-buttons">
                <button @click="changeCurrentPeriod('monthly')" :disabled="hasMonthly === false" :class="[ hasMonthly === true ? 'fme-overview-periods__group-buttons--has' : '', currentPeriod === 'monthly' ? 'fme-overview-periods__group-buttons--active' : '' ]">{{ $t('supervision.overview.period.monthly') }}</button>
                <button @click="changeCurrentPeriod('biweekly')" :disabled="hasBiweekly === false" :class="[ hasBiweekly === true ? 'fme-overview-periods__group-buttons--has' : '', currentPeriod === 'biweekly' ? 'fme-overview-periods__group-buttons--active' : '' ]">{{ $t('supervision.overview.period.biweekly') }}</button>
                <button @click="changeCurrentPeriod('weekly')" :disabled="hasWeekly === false" :class="[ hasWeekly === true ? 'fme-overview-periods__group-buttons--has' : '', currentPeriod === 'weekly' ? 'fme-overview-periods__group-buttons--active' : '' ]">{{ $t('supervision.overview.period.weekly') }}</button>
              </div>
            </div>
          </div>

          <div class="row" v-if="notPeriods === true">
            <div class="col-md-12">
              <p>{{ $t('supervision.overview.message.noPeriodSelectOtherRegion') }}</p>
            </div>
          </div>

          <div v-if="noContentPeriod === true" class="row">
            <div class="col-md-12">{{ $t('supervision.overview.message.noContentForPeriod') }}</div>
          </div>

          <div v-if="notCard === false" class="row fme-overview-home__cards">
            <div class="col-md-12 fme-small-cards">
              <div class="row fme-small-cards-row">
                <div class="col-md-12">
                  <div class="fme-small-card" v-for="(item, index) in journeysLineOne" :key="index">
                    <a @click.prevent="activeCard(item.id, item.title)" class="fme-montserrat-font router-anchor fme-card-small" :class="[ cardActive === item.id ? 'active-card' : '']">
                      <div class="fme-small-base-card">
                        <div class="fme-small-card__title base-card__title-small fme-montserrat-font">
                          {{ item.title }}
                        </div>

                        <div class="fme-small-card__numberpercent fme-montserrat-font">
                          <div>
                            <span>{{ item.visits_done }}/</span>
                            <span>{{ item.visits_journey }}</span>
                          </div>
                            <h3>{{ $t(`supervision.overview.card.legends.${item.visits_legend}`) }}</h3>
                        </div>

                        <div class="fme-small-card__link-more">>> {{ $t('supervision.overview.card.button') }}</div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="row fme-small-cards-row">
                <div class="col-md-12">
                  <div class="fme-small-card" v-for="(item, index) in journeysLineTwo" :key="index">
                    <a @click.prevent="activeCard(item.id, item.title)" class="fme-montserrat-font router-anchor fme-card-small" :class="[ cardActive === item.id ? 'active-card' : '']">
                      <div class="fme-small-base-card">
                        <div class="fme-small-card__title base-card__title-small fme-montserrat-font">
                          {{ item.title }}
                        </div>

                        <div class="fme-small-card__numberpercent fme-montserrat-font">
                          <div>
                            <span>{{ item.visits_done }}/</span>
                            <span>{{ item.visits_journey }}</span>
                          </div>
                            <h3>{{ $t(`supervision.overview.card.legends.${item.visits_legend}`) }}</h3>
                        </div>

                        <div class="fme-small-card__link-more">>> {{ $t('supervision.overview.card.button') }}</div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="listVisible === true" class="row fme-overview-home__list">
            <div class="col-md-12">
              <div class="row fme-overview-home__list--menu">
                <div class="col-md-3 fme-overview-home__list--menu-title fme-montserrat-font">
                  <h3 class=""> {{ currentJourney }} </h3>
                </div>

                <div class="col-md-9 fme-overview-home__list--menu-actions text-right">
                  <button @click.prevent="activeListButtom('asc')" class="btn fme-btn fme-btn-silver" :class="[ currentActiveListButtom !== 'asc' ? '' : 'fme-btn-silver__active' ]">{{ $t('supervision.overview.button.lessVisited') }}</button>
                  <button @click.prevent="activeListButtom('desc')" class="btn fme-btn fme-btn-silver" :class="[ currentActiveListButtom !== 'desc' ? '' : 'fme-btn-silver__active' ]">{{ $t('supervision.overview.button.mostVisited') }}</button>

                  <div class="display-none">
                    <BaseSearchFilterInput inputType="text" :inputItemsList="['a', 'b', 'c']" :inputField="searchField" :inputPlaceholder="$t('supervision.crud.search.location')" inputCss="" @itemsFound="receivingSearchResponse" class="fme-list__search-field" />
                  </div>
                </div>
              </div>

              <div v-if="notJourneysSchedules === true" class="row">
                <div class="col-md-12">
                  <p>Sem informações para mostrar</p>
                </div>
              </div>

              <div v-if="listItemsVisible === true" class="row">
                <div class="col-md-12">
                  <p v-if="searchNotFound">Não encontramos resultados para: <strong> {{ searchFieldText }} </strong> <button @click="clearSearchNotFound">X</button></p>

                  <ul class="fme-overview-home__list--items">
                    <li v-for="(item, index) in journeysSchedules" :key="index" class="fme-overview-home__list--items-item">
                      <h5 v-if="item.visits_done > 0" class="fme-overview-home__list--item-title fme-montserrat-font">
                        <a @click.prevent="getLastVisit(item.id, item.location.id)">{{ item.location.name }}</a>
                      </h5>
                      <h5 v-else class="fme-overview-home__list--item-title-not-hover fme-montserrat-font">
                        <span>{{ item.location.name }}</span>
                      </h5>

                      <p class="fme-overview-home__list--item-address fme-hind-font">{{ item.location.address }}</p>

                      <div class="fme-overview-home__list--item-numbers">
                        <div class="fme-overview-home__list--item-numberpercent fme-montserrat-font">
                          <div>
                            <span>{{ item.visits_done }}/</span>
                            <span>{{ item.visits_in_journey }}</span>
                          </div>
                          <h3>{{ $t('supervision.overview.card.legends.visits') }}</h3>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

import axios from 'axios'

const BaseSelect = () => import('@/components/fragment/select/BaseSelect')
const BaseSearchFilterInput = () => import('@/components/fragment/input/BaseSearchFilterInput')

export default {
  name: 'ListHomePage',
  created () {
    this.changeCrudPage(false)
    this.changeMetricPage(false)
    this.changeReportPage(false)
    this.changeVisitsPageOverview(true)
    // this.clearJourneysSchedulesOverview()
    this.startPage()
  },
  mounted () {
    // this.listVisible = false
    // this.clearJourneysSchedulesOverview()
  },
  updated () {
    this.changeVisitsPageOverview(true)
  },
  beforeDestroy () {
    this.changeVisitsPageOverview(false)
    // this.listVisible = false
    // this.clearJourneysSchedulesOverview()
  },
  data () {
    return {
      regionsUrl: `${process.env.VUE_APP_REGIONS_API}?fields=id,name&status=active`,
      regionUrl: process.env.VUE_APP_REGIONS_API,
      regionJourney: process.env.VUE_APP_OVERVIEW_JOURNEY_API,
      locationLastVisit: process.env.VUE_APP_LOCATIONS_API,
      selectVisible: false,
      selectRegions: {
        'default': 'supervision.crud.select.region.placeholder',
        'options': []
      },
      cardActive: 0,
      listVisible: false,
      listItemsVisible: false,
      currentPeriod: '',
      currentJourney: '',
      currentIdJourney: '',
      currentActiveListButtom: 'desc',
      searchField: '',
      searchFieldText: '',
      searchNotFound: false,
      hasMonthly: false,
      hasWeekly: false,
      hasBiweekly: false,
      hasJourneys: false,
      hasStartEndPeriod: false,
      hasNoEndPeriod: false,
      notPeriods: false,
      notCard: true,
      noContentPeriod: false,
      notJourneysSchedules: false
    }
  },
  components: {
    BaseSelect,
    BaseSearchFilterInput
  },
  computed: {
    ...mapGetters(['axiosHeaders1']),
    ...mapGetters('ModuleOverview', [
      'startEndPeriod',
      'hasHistoryOverview',
      'historyContentOverview',
      'regionsOverview',
      'regionIdOverview',
      'regionNameOverview',
      'journeysLineOneOverview',
      'journeysLineTwoOverview',
      'journeysSchedulesOverview'
    ]),
    regions () {
      return this.regionsOverview
    },
    regionId () {
      return this.regionIdOverview
    },
    regionName () {
      return this.regionNameOverview
    },
    startEndSelectedPeriod () {
      return this.startEndPeriod
    },
    journeysLineOne () {
      return this.journeysLineOneOverview
    },
    journeysLineTwo () {
      return this.journeysLineTwoOverview
    },
    journeysSchedules () {
      return this.journeysSchedulesOverview
    }
  },
  methods: {
    ...mapActions('ModuleOverview', [
      'changeHasHistoryOverview',
      'changeHistoryContentOverview',
      'clearHistoryOverview',
      'changeVisitsPageOverview',
      'changeRegionsOverview',
      'clearRegionsOverview',
      'changeRegionIdOverview',
      'changeRegionNameOverview',
      'clearRegionOverview',
      'changeStartEndPeriodVisitOverview',
      'clearStartEndPeriodVisitOverview',
      'changeJourneysLineOneOverview',
      'changeJourneysLineTwoOverview',
      'clearJourneysOverview',
      'changeJourneysSchedulesOverview',
      'clearJourneysSchedulesOverview'
    ]),
    ...mapActions('ModuleSupervision', [
      'changeCrudPage'
    ]),
    ...mapActions('ModuleMetric', [
      'changeMetricPage'
    ]),
    ...mapActions('ModuleReport', [
      'changeReportPage'
    ]),
    activeListButtom (buttonName) {
      if (buttonName !== this.currentActiveListButtom) {
        this.currentActiveListButtom = buttonName
        this.clearHistoryOverview()
        this.getJourneysSchedules(this.currentIdJourney)
      }
    },
    activeCard (value, name) {
      if (this.journeysSchedulesOverview.length > 0) {
        this.clearJourneysSchedulesOverview()
      }
      this.currentActiveListButtom = 'desc'
      this.notJourneysSchedules = false
      this.cardActive = value
      this.currentJourney = name
      this.currentIdJourney = value
      this.clearHistoryOverview()
      this.getJourneysSchedules(value)
    },
    startPage () {
      if (this.hasHistoryOverview === false) {
        this.listVisible = false
        this.listItemsVisible = false
        this.getRegions()
      } else {
        this.getRegions()
      }
    },
    getRegions () {
      this.notCard = true
      this.noContentPeriod = false
      this.cardActive = 0
      this.currentIdJourney = ''
      this.currentJourney = ''
      this.currentActiveListButtom = 'desc'
      this.clearRegionsOverview([])
      this.clearRegionOverview()
      this.clearJourneysOverview([])
      this.clearJourneysSchedulesOverview()

      axios.get(this.regionsUrl, {
        headers: this.axiosHeaders1
      })
        .then(response => {
          let regions = response.data.data
          let newRegions = []

          regions.forEach((value, index, array) => {
            let newObj = {
              'name': value.id,
              'value': value.name
            }

            newRegions.push(newObj)
          })

          return newRegions
        })
        .then((regions) => {
          this.selectRegions.options = regions
          this.selectVisible = true

          if (this.hasHistoryOverview === false) {
            this.listVisible = false
            this.listItemsVisible = false
          } else {
            let historyStore = this.historyContentOverview

            axios.get(`${this.regionUrl}/${historyStore.regionId}`, {
              headers: this.axiosHeaders1
            })
              .then(response => {
                return response.data.data
              })
              .then(region => {
                this.changeRegionIdOverview(region.id)
                this.changeRegionNameOverview(region.name)
              })

            this.notPeriods = historyStore.notPeriods
            this.hasWeekly = historyStore.hasWeekly
            this.hasBiweekly = historyStore.hasBiweekly
            this.hasMonthly = historyStore.hasMonthly
            this.currentPeriod = historyStore.currentPeriod
            this.changeStartEndPeriodVisitOverview(historyStore.startEndPeriod)
            this.hasNoEndPeriod = historyStore.hasNoEndPeriod
            this.notCard = historyStore.notCard
            this.noContentPeriod = historyStore.noContentPeriod
            this.changeJourneysLineOneOverview(historyStore.journeysLineOne)
            this.changeJourneysLineTwoOverview(historyStore.journeysLineTwo)
            this.hasJourneys = historyStore.hasJourneys
            this.notJourneysSchedules = historyStore.notJourneysSchedules
            this.listVisible = historyStore.listVisible
            this.listItemsVisible = historyStore.listItemsVisible
            this.cardActive = historyStore.cardActive
            this.currentActiveListButtom = historyStore.currentActiveListButtom
            this.getJourneysSchedules(historyStore.currentIdJourney)
            this.currentIdJourney = historyStore.currentIdJourney
            this.currentJourney = historyStore.currentJourney
          }
        })
        .catch(e => {
          if (e.response.status && e.response.status === 401) {
            this.logoutUser()
          } else {
            console.log(e)
          }
        })
    },
    async regionSelect (refValue, event) {
      if (refValue === 'region') {
        this.hasJourneys = false
        this.currentPeriod = ''
        this.notCard = true
        this.noContentPeriod = false
        this.cardActive = 0
        this.listVisible = false
        this.listItemsVisible = false
        this.currentIdJourney = ''
        this.currentJourney = ''
        this.currentActiveListButtom = 'desc'
        this.clearJourneysOverview([])
        this.clearJourneysSchedulesOverview()
        this.hasMonthly = false
        this.hasWeekly = false
        this.hasBiweekly = false
        this.notPeriods = false
        this.notJourneysSchedules = false
        this.clearHistoryOverview()

        let stepOne = false
        let stepTwo = false
        let stepThree = false

        const region = await axios.get(`${this.regionUrl}/${event}`, {
          headers: this.axiosHeaders1
        })
          .then(response => {
            return response.data.data
          })
          .then(region => {
            this.changeRegionIdOverview(region.id)
            this.changeRegionNameOverview(region.name)
            return region.id
          })

        const monthly = await axios.get(`${this.regionUrl}/${region}/journeys?filters=period.eq.monthly`, {
          headers: this.axiosHeaders1
        })
          .then(response => {
            stepOne = true
            return response.data.data
          })

        const weekly = await axios.get(`${this.regionUrl}/${region}/journeys?filters=period.eq.weekly`, {
          headers: this.axiosHeaders1
        })
          .then(response => {
            stepTwo = true
            return response.data.data
          })

        const biweekly = await axios.get(`${this.regionUrl}/${region}/journeys?filters=period.eq.biweekly`, {
          headers: this.axiosHeaders1
        })
          .then(response => {
            stepThree = true
            return response.data.data
          })

        if (stepOne === true && stepTwo === true && stepThree === true) {
          if (!monthly.length > 0 && !weekly.length > 0 && !biweekly.length > 0) {
            this.notPeriods = true
          } else {
            if (monthly.length > 0) {
              this.hasMonthly = true
            }
            if (weekly.length > 0) {
              this.hasWeekly = true
            }
            if (biweekly.length > 0) {
              this.hasBiweekly = true
            }
          }
        } else {
          this.notPeriods = true
        }
      }
    },
    getRegionJourney () {
      this.clearJourneysSchedulesOverview()
      this.currentJourney = ''

      let startFormat = moment(this.startEndSelectedPeriod.startPeriod).format('YYYY-MM-DD')
      let endFormat = moment(this.startEndSelectedPeriod.endPeriod).format('YYYY-MM-DD')

      let newStartDate = startFormat
      let newEndDate = endFormat

      let url = `${this.regionUrl}/${this.regionId}/journeys?filters=period.eq.${this.currentPeriod},start_date::date.gte.${newStartDate},end_date::date.lte.${newEndDate}`

      axios.get(url, {
        headers: this.axiosHeaders1
      })
        .then(response => {
          let journey = response.data.data
          let journeyCount = journey.length
          let listOne = []
          let listTwo = []

          if (journeyCount > 0) {
            for (let i = 0; i < journeyCount; i++) {
              if (i < 4) {
                let newObj = {
                  'id': journey[i].id,
                  'title': journey[i].name,
                  'visits_done': journey[i].total_visits_done,
                  'visits_journey': journey[i].total_visits_in_journey,
                  'visits_legend': 'visits',
                  'region': this.regionId
                }

                listOne.push(newObj)
              } else {
                let newObj = {
                  'id': journey[i].id,
                  'title': journey[i].name,
                  'visits_done': journey[i].total_visits_done,
                  'visits_journey': journey[i].total_visits_in_journey,
                  'visits_legend': 'visits',
                  'region': this.regionId
                }

                listTwo.push(newObj)
              }
            }
            this.hasJourneys = true
            this.notCard = false
            this.noContentPeriod = false
          } else {
            this.hasJourneys = false
            this.notCard = true
            this.noContentPeriod = true
          }
          this.changeJourneysLineOneOverview(listOne)
          this.changeJourneysLineTwoOverview(listTwo)
        })
        .catch(e => {
          console.log(e)
          if (e.response.status && e.response.status === 401) {
            this.logoutUser()
          } else {
            console.log(e)
          }
        })
    },
    getJourneysSchedules (id) {
      axios.get(`${this.regionJourney}/${id}/schedules?eager=location(all)&sort_visits_done=${this.currentActiveListButtom}`, {
        headers: this.axiosHeaders1
      })
        .then(response => {
          this.clearJourneysSchedulesOverview()
          return response.data.data
        })
        .then(journeysSchedules => {
          this.listVisible = true

          if (!journeysSchedules.length > 0) {
            this.notJourneysSchedules = true
            this.listItemsVisible = false
          } else {
            this.notJourneysSchedules = false
            this.listItemsVisible = true
            this.changeJourneysSchedulesOverview(journeysSchedules)
          }
        })
        .catch(e => {
          if (e.response.status && e.response.status === 401) {
            this.logoutUser()
          } else {
            console.log(e)
          }
        })
    },
    async changeCurrentPeriod (newPeriod) {
      if (this.currentPeriod !== newPeriod && this.regionId !== '') {
        this.clearJourneysSchedulesOverview()
        await this.getStartEndPeriod(newPeriod)
        this.currentPeriod = newPeriod
        this.cardActive = 0
        this.notCard = true
        this.noContentPeriod = false
        this.listVisible = false
        this.listItemsVisible = false
        this.notJourneysSchedules = false
        this.currentActiveListButtom = 'desc'
        this.getRegionJourney()
        this.clearHistoryOverview()
      }
    },
    async getStartEndPeriod (period) {
      let start = await this.calcStart(period)
      let end = await this.calcEnd(period)
      let month = parseInt(moment(start).format('MM'), 10)
      let monthName = moment(start).locale('pt-br').format('MMM')
      let year = parseInt(moment(start).format('YYYY'), 10)
      let sDay = parseInt(moment(start).format('DD'), 10)
      let eDay = parseInt(moment(end).format('DD'), 10)
      let sMonth = moment(start).locale('pt-br').format('MMM')
      let eMonth = moment(end).locale('pt-br').format('MMM')
      let sYear = parseInt(moment(start).format('YYYY'), 10)
      let eYear = parseInt(moment(end).format('YYYY'), 10)

      let starEndPeriod = {
        startPeriod: start,
        endPeriod: end,
        startDay: sDay,
        endDay: eDay,
        startMonth: sMonth,
        endMonth: eMonth,
        startYear: sYear,
        endYear: eYear,
        month: month,
        monthName: monthName,
        year: year
      }

      this.changeStartEndPeriodVisitOverview(starEndPeriod)
    },
    calcStart (period, date = moment()) {
      const referenceDate = moment(date)

      switch (period) {
        case 'monthly':
          return referenceDate.startOf('month')
        case 'biweekly':
          const day = referenceDate.date() <= 15 ? 1 : 16
          return moment([referenceDate.year(), referenceDate.month(), day])
        default:
          return referenceDate.startOf('week')
      }
    },
    calcEnd (period, date = moment()) {
      const referenceDate = moment(date)
      let lastDay = referenceDate.endOf('month').date()

      switch (period) {
        case 'monthly':
          return referenceDate.endOf('month')
        case 'biweekly':
          const day = referenceDate.date() <= 15 ? 15 : lastDay
          return moment([referenceDate.year(), referenceDate.month(), day, 23, 59, 59, 999])
        default:
          return moment().endOf('week')
      }
    },
    updateCurrentPeriod (value) {
      let currentPeriod = this.currentPeriod
      let currentMonth = moment().month() + 1
      let currentYear = moment().year()
      let selectedButton = value
      let startPeriod = moment(this.startEndSelectedPeriod.startPeriod)
      let newStartPeriod = ''
      let newEndPeriod = ''
      let newStartDay = 0
      let newEndDay = 0
      let newMonth = 0
      let newYear = 0
      let month = 0
      let monthName = ''
      let year = 0
      let sDay = 0
      let eDay = 0
      let sMonth = ''
      let eMonth = ''
      let sYear = 0
      let eYear = 0

      if (selectedButton === '+') {
        if (currentPeriod === 'monthly') {
          newStartPeriod = startPeriod.startOf('month').add(1, 'M')
          newEndPeriod = moment(newStartPeriod).endOf('month')
          sDay = parseInt(newStartPeriod.date(), 10)
          eDay = parseInt(newEndPeriod.date(), 10)
          month = parseInt(moment(newStartPeriod).format('MM'), 10)
          monthName = moment(newStartPeriod).locale('pt-br').format('MMM')
          year = parseInt(moment(newStartPeriod).format('YYYY'), 10)

          if (year <= currentYear) {
            if (year === currentYear && month >= currentMonth) {
              this.hasNoEndPeriod = true
            } else {
              this.hasNoEndPeriod = false
            }
          } else {
            this.hasNoEndPeriod = true
          }
        } else if (currentPeriod === 'biweekly') {
          if (moment(startPeriod).date() >= 16) {
            newStartDay = 1
            newEndDay = 15
            sDay = 1
            eDay = 15

            newMonth = moment(startPeriod).add(1, 'M')
            if (newMonth.month() === 0) {
              newYear = moment(startPeriod).add(1, 'y').year()
            } else {
              newYear = moment(startPeriod).year()
            }

            newStartPeriod = moment([newYear, moment(newMonth).month(), newStartDay])
            newEndPeriod = moment([newYear, moment(newMonth).month(), newEndDay, 23, 59, 59, 999])
            month = parseInt(moment(newMonth).format('MM'), 10)
            monthName = moment(newMonth).locale('pt-br').format('MMM')
            year = parseInt(moment(newStartPeriod).format('YYYY'), 10)

            if (year <= currentYear) {
              if (year === currentYear && month >= currentMonth && newStartDay >= 16) {
                this.hasNoEndPeriod = true
              } else {
                this.hasNoEndPeriod = false
              }
            } else {
              this.hasNoEndPeriod = true
            }
          } else {
            newStartDay = 16
            newEndDay = moment(startPeriod).endOf('month').subtract(1, 'd').date()
            sDay = 16
            eDay = moment(startPeriod).endOf('month').date()
            newStartPeriod = moment([moment(startPeriod).year(), moment(startPeriod).month(), newStartDay])
            newEndPeriod = moment([moment(startPeriod).year(), moment(startPeriod).month(), newEndDay, 23, 59, 59, 999])
            month = parseInt(moment(startPeriod).format('MM'), 10)
            monthName = moment(startPeriod).locale('pt-br').format('MMM')
            year = parseInt(moment(startPeriod).format('YYYY'), 10)

            if (year <= currentYear) {
              if (year === currentYear && month >= currentMonth && newStartDay >= 16) {
                this.hasNoEndPeriod = true
              } else {
                this.hasNoEndPeriod = false
              }
            } else {
              this.hasNoEndPeriod = true
            }
          }
        } else {
          let currentDay = moment()
          newStartPeriod = moment(startPeriod).day(7)
          newEndPeriod = moment(newStartPeriod).endOf('week')
          sDay = moment(newStartPeriod).date()
          eDay = moment(newEndPeriod).date()
          sMonth = moment(newStartPeriod).locale('pt-br').format('MMM')
          eMonth = moment(newEndPeriod).locale('pt-br').format('MMM')
          sYear = parseInt(moment(newStartPeriod).format('YYYY'), 10)
          eYear = parseInt(moment(newEndPeriod).format('YYYY'), 10)
          month = parseInt(moment(newStartPeriod).format('MM'), 10)
          monthName = moment(newStartPeriod).locale('pt-br').format('MMM')
          year = parseInt(moment(newStartPeriod).format('YYYY'), 10)

          if (moment(currentDay).isBetween(newStartPeriod, newEndPeriod)) {
            this.hasNoEndPeriod = true
          } else {
            this.hasNoEndPeriod = false
          }
        }
      } else {
        if (currentPeriod === 'monthly') {
          newStartPeriod = startPeriod.startOf('month').subtract(1, 'M')
          newEndPeriod = moment(newStartPeriod).endOf('month')
          sDay = parseInt(newStartPeriod.date(), 10)
          eDay = parseInt(newEndPeriod.date(), 10)
          month = parseInt(moment(newStartPeriod).format('MM'), 10)
          monthName = moment(newStartPeriod).locale('pt-br').format('MMM')
          year = parseInt(moment(newStartPeriod).format('YYYY'), 10)

          this.hasNoEndPeriod = false
        } else if (currentPeriod === 'biweekly') {
          if (moment(startPeriod).date() <= 15) {
            newStartDay = 16

            newMonth = moment(startPeriod).subtract(1, 'M')
            if (newMonth.month() === 11) {
              newYear = moment(startPeriod).subtract(1, 'y').year()
            } else {
              newYear = moment(startPeriod).year()
            }

            newEndDay = moment(newMonth).endOf('month').date()
            sDay = 16
            eDay = moment(newMonth).endOf('month').date()
            newStartPeriod = moment([newYear, moment(newMonth).month(), newStartDay])
            newEndPeriod = moment([newYear, moment(newMonth).month(), newEndDay, 23, 59, 59, 999])
            month = parseInt(moment(newStartPeriod).format('MM'), 10)
            monthName = moment(newStartPeriod).locale('pt-br').format('MMM')
            year = parseInt(moment(newStartPeriod).format('YYYY'), 10)
          } else {
            newStartDay = 1
            newEndDay = 15
            sDay = 1
            eDay = 15
            newStartPeriod = moment([moment(startPeriod).year(), moment(startPeriod).month(), newStartDay])
            newEndPeriod = moment([moment(startPeriod).year(), moment(startPeriod).month(), newEndDay, 23, 59, 59, 999]).subtract(1, 'd')
            month = parseInt(moment(startPeriod).format('MM'), 10)
            monthName = moment(startPeriod).locale('pt-br').format('MMM')
            year = parseInt(moment(startPeriod).format('YYYY'), 10)
          }

          this.hasNoEndPeriod = false
        } else {
          newStartPeriod = moment(startPeriod).day(-7)
          newEndPeriod = moment(newStartPeriod).endOf('week')
          sDay = moment(newStartPeriod).date()
          eDay = moment(newEndPeriod).add(1, 'd').date()
          sMonth = moment(newStartPeriod).locale('pt-br').format('MMM')
          eMonth = moment(newEndPeriod).locale('pt-br').format('MMM')
          sYear = parseInt(moment(newStartPeriod).format('YYYY'), 10)
          eYear = parseInt(moment(newEndPeriod).format('YYYY'), 10)
          month = parseInt(moment(newStartPeriod).format('MM'), 10)
          monthName = moment(newStartPeriod).locale('pt-br').format('MMM')
          year = parseInt(moment(newStartPeriod).format('YYYY'), 10)

          this.hasNoEndPeriod = false
        }
      }

      let newDateTime = {
        startPeriod: newStartPeriod,
        endPeriod: newEndPeriod,
        startDay: sDay,
        endDay: eDay,
        startMonth: sMonth,
        endMonth: eMonth,
        startYear: sYear,
        endYear: eYear,
        month: month,
        monthName: monthName,
        year: year
      }

      this.changeStartEndPeriodVisitOverview(newDateTime)

      this.cardActive = 0
      this.notCard = true
      this.noContentPeriod = false
      this.listVisible = false
      this.listItemsVisible = false
      this.notJourneysSchedules = false
      this.currentActiveListButtom = 'desc'
      this.getRegionJourney()
      this.clearHistoryOverview()
    },
    getNumbers (type, card) {
      type.forEach((item, index, array) => {
        let url = card[item].url
        let oldCard = this.cards[item]

        axios.get(url, {
          headers: this.axiosHeaders1
        })
          .then(response => {
            return response.data.data
          })
          .then(data => {
            oldCard.number = parseInt(data.count, 10)
          })
          .catch(e => {
            oldCard.number = 0
            if (e.response.status && e.response.status === 401) {
              this.logoutUser()
            } else {
              console.log(e)
            }
          })
      })
    },
    receivingSearchResponse (searchResponse) {
      /*
      if (searchResponse[0].length > 0) {
        this.searchNotFound = false
        this.list = searchResponse[0]
        this.listItemsCount = searchResponse[0].length
      } else {
        let oldItems = this.gettingApiItems()

        if (this.list !== oldItems) {
          this.list = oldItems
        }

        if (searchResponse[2] === 'cleaning') {
          this.searchNotFound = false
          this.searchFieldText = ''
        } else {
          this.searchNotFound = true
          this.searchFieldText = searchResponse[1]
        }
      }
      */
    },
    getLastVisit (id, locationId) {
      this.clearHistoryOverview()
      let url = `${this.locationLastVisit}/${locationId}/visits?fields=id,started_at,finished_at,kind,previous_id,following_id&eager=[journey,itinerary,supervisor,location,schedule]&filters=schedule_id.eq.${id}&sort=started_at.desc&page=1.1`

      axios.get(url, {
        headers: this.axiosHeaders1
      })
        .then(response => {
          return response.data.data
        })
        .then(route => {
          let history = {}

          history.journeysLineOne = this.journeysLineOne
          history.journeysLineTwo = this.journeysLineTwo
          history.hasJourneys = true
          history.notCard = false
          history.noContentPeriod = this.noContentPeriod
          history.currentPeriod = this.currentPeriod
          history.startEndPeriod = this.startEndPeriod
          history.hasNoEndPeriod = this.hasNoEndPeriod
          history.listVisible = true
          history.selectVisible = true
          history.listItemsVisible = true
          history.notJourneysSchedules = false
          history.cardActive = this.cardActive
          history.currentIdJourney = this.currentIdJourney
          history.currentJourney = this.currentJourney
          history.currentActiveListButtom = this.currentActiveListButtom

          if (this.hasMonthly) {
            history.hasMonthly = this.hasMonthly
          } else {
            history.hasMonthly = false
          }

          if (this.hasBiweekly) {
            history.hasBiweekly = this.hasBiweekly
          } else {
            history.hasBiweekly = false
          }

          if (this.hasWeekly) {
            history.hasWeekly = this.hasWeekly
          } else {
            history.hasWeekly = false
          }

          history.notPeriods = false
          history.regionId = this.regionIdOverview
          history.regionName = this.regionNameOverview

          this.changeHistoryContentOverview(history)
          this.changeHasHistoryOverview(true)
          this.$router.push({ name: 'VisitsPage', params: { id: route[0].id } })
        })
        .catch(e => {
          if (e.response.status && e.response.status === 401) {
            this.logoutUser()
          } else {
            console.log(e)
          }
        })
    },
    clearSearchNotFound () {
      // this.gettingApiItems()
      this.searchNotFound = false
      this.searchFieldText = ''
    }
  },
  filters: {
  }
}
</script>

<style lang="scss">
.fme-overview-home__title {
  padding-left: 12px;
  padding-bottom: 5px;
  h1 {
    font-size: 24px;
    font-weight: 800;
    line-height: 34px;
    text-transform: uppercase;
    color: $fme-color__space-cadet;
    margin-bottom: 18px;
  }
}
.fme-overview-period-select {
  margin-bottom: 12px;
  .fme-overview-period-select__button {

  }
  .fme-overview-period-select__text {
    display: inline-block;
    font-size: 24px;
    font-weight: 800;
    color: $fme-color__old-silver;
    margin-left: 12px;
    margin-right: 24px;
    vertical-align: middle;
    text-transform: lowercase;
    p {
      margin: 0;
    }
  }
}
.fme-overview-menu {
  .fme-overview-select {
  }
  .fme-overview-periods {
    text-align: right;
    .fme-overview-periods__group-buttons {
      button {
        font-family: 'Montserrat', sans-serif;
        color: $fme-color__write;
        background: $fme-color__yale-blue;
        font-size: 14px;
        font-weight: 700;
        text-transform: uppercase;
        padding: 15px 58px 15px 68px;
        border:1px solid $fme-color__old-silver;
        transition: background 0.3s ease-in-out;
        pointer-events: all;
        cursor: pointer;
        &:disabled {
          cursor: not-allowed;
          background: $fme-color__silver-chalice--disable;
          border:1px solid #ebebeb;
        }
        &:first-child {
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
        }
        &:last-child {
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
        }
        &.fme-overview-periods__group-buttons--has {
          color: $fme-color__write;
          background: $fme-color__yale-blue;
          &:hover {
            color: $fme-color__yale-blue;
            background: $fme-color__light-silver;

        -webkit-box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
           -moz-box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
                box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
          }
        }
        &.fme-overview-periods__group-buttons--active {
          color: $fme-color__yale-blue;
          background: $fme-color__light-silver;
          &:hover {
            -webkit-box-shadow: none;
               -moz-box-shadow: none;
                    box-shadow: none;
          }
        }
      }
    }
  }
}
.fme-overview-home__cards {
  margin-top: 30px;
  margin-bottom: 32px;
    .fme-small-card {
      min-width: 332px;
      display: inline-block;
      padding-top: 15px;
      padding-bottom: 15px;
      &:not(:first-child) {
        margin-left: 12px;
      }
      a {
        text-decoration: none;
        color: $fme-color__yale-blue;
        .fme-small-card__title {
          font-weight: 800;
          &.base-card__title-small {
            font-size: 24px;
            p {
              margin: 0 0 60px 0;
            }
          }
        }
        &:hover {
          cursor: pointer;
          .fme-small-card__title {
            color: $fme-color__celestial-blue;
          }
        }
        &.active-card {
          .fme-small-card__title {
            color: $fme-color__celestial-blue;
          }
          .fme-small-base-card {
            -webkit-box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
              -moz-box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
                    box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
          }
        }
        .fme-small-base-card {
          height: 157px;
          min-height: 157px;
          position: relative;
          overflow: hidden;
          border-radius: 10px;
          background: $fme-color__write;
          padding: 25px 15px 15px 15px;
          -webkit-box-shadow: 0px 2px 4px 2px rgba(0,0,0,0.09);
            -moz-box-shadow: 0px 2px 4px 2px rgba(0,0,0,0.09);
                  box-shadow: 0px 2px 4px 2px rgba(0,0,0,0.09);
          transition: box-shadow 0.3s ease-in-out;
          &:hover {
            -webkit-box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
              -moz-box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
                    box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
          }
          .fme-small-card__numberpercent {
            position: absolute;
            right: 15px;
            bottom: 11px;
            color: $fme-color__flame;
            text-align: right;
            div {
              display: inline-block;
              height: 42px;
              max-height: 42px;
              font-family: 'Hind', sans-serif;
              margin-bottom: 0;
              font-weight: 400;
              span {
                display: inline-block;
                &:nth-child(1) {
                  font-size: 22px;
                  vertical-align: top;
                  padding-top: 5px;
                  padding-right: 3px;
                }
                &:nth-child(2) {
                  font-size: 38px;
                  font-weight: 600;
                }
              }
            }
            h3 {
              font-family: 'Montserrat', sans-serif;
              font-weight: 400;
              font-size: 23px;
              margin-top: -6px;
            }
          }
          .fme-small-card__link-more {
            font-size: 14px;
            font-weight: 700;
            text-transform: uppercase;
            margin: 56px 0 0 0;
            p {
              margin: 0;
            }
          }
        }
      }
    }
}
.fme-overview-home__list {
  padding-bottom: 38px;
  .fme-overview-home__list--menu {
    .fme-overview-home__list--menu-title {
      h3 {
        padding-top: 13px;
        padding-left: 12px;
        font-size: 24px;
        font-weight: 800;
        color: $fme-color__dark-silver;
      }
    }
    .fme-overview-home__list--menu-actions {
      padding-top: 4px;
      button {
        &:not(:first-child) {
          margin-left: 12px;
        }
      }
      .fme-list__search-field {
        margin-left: 10px;
        margin-right: 10px;
      }
    }
  }
  .fme-overview-home__list--items {
    list-style-type: none;
    margin-top: 35px;
    .fme-overview-home__list--items-item {
      font-size: 14px;
      padding: 22px 12px;
      overflow: hidden;
      background: $fme-color__ghost-white;
      &:nth-child(2n+2) {
        background: $fme-color__baby-powder;
      }
      .fme-overview-home__list--item-title {
        cursor: pointer;
        a {
          text-decoration: none;
          font-weight: 700;
          color: $fme-color__yale-blue;
          margin-bottom: 0;
          &:hover {
            color: $fme-color__celestial-blue;
          }
        }
      }
      .fme-overview-home__list--item-title-not-hover {
        span {
          text-decoration: none;
          font-weight: 700;
          color: $fme-color__old-silver;
          margin-bottom: 0;
        }
      }
      .fme-overview-home__list--item-address {
        font-weight: 400;
        color: $fme-color__dark-silver;
        margin-bottom: 0;
      }
      .fme-overview-home__list--item-numbers {
        position: relative;
        .fme-overview-home__list--item-numberpercent {
          position: absolute;
          right: -11px;
          bottom: -14px;
          color: $fme-color__old-silver;
          text-align: right;
          padding-right: 11px;
          div {
            display: inline-block;
            height: 42px;
            max-height: 42px;
            font-family: 'Hind', sans-serif;
            margin-bottom: 0;
            font-weight: 400;
            span {
              display: inline-block;
              &:nth-child(1) {
                font-size: 22px;
                vertical-align: top;
                padding-top: 5px;
                padding-right: 3px;
              }
              &:nth-child(2) {
                font-size: 38px;
                font-weight: 600;
              }
            }
          }
          h3 {
            font-family: 'Montserrat', sans-serif;
            font-weight: 400;
            font-size: 23px;
            margin-top: -6px;
          }
        }
      }
    }
  }
}
</style>
